import { BaseDto } from "../common/baseDto";

export interface StockDto extends BaseDto {

	
	logicCenter: string;
	logicCenterNm: string;
	warehouseCd: string;
	warehouseNm: string;
	itemCd: string;
	itemNm: string;
	itemSpec: string;
	itemStatus: string;
	itemUnit: string;

	// 재고 관련 필드
	stockQty: number;
	reservQty: number;
	availableQty: number;

	inserted: boolean;
	isModified: boolean;
}

/**
 * 재고 관리의 단일 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultStockData: StockDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	
	logicCenter: '',
	logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	itemUnit: '',

	stockQty: 0,
	reservQty: 0,
	availableQty: 0,

	inserted: false,
	isModified: false
};
